import { render } from "./OrdersInfoCodeView .vue?vue&type=template&id=3f7c43ab"
import script from "./OrdersInfoCodeView .vue?vue&type=script&lang=js"
export * from "./OrdersInfoCodeView .vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__